import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';
import { Text } from '@wix/wix-ui-tpa/cssVars';

import settingsParams from '../../../settingsParams';
import { classes, st } from './EmptyState.st.css';

export const EmptyState: FC = () => {
  const settings = useSettings();
  const { isMobile } = useEnvironment();

  return (
    <div className={st(classes.root, { mobile: isMobile })}>
      <div className={classes.content}>
        <Text tagName="H2" className={classes.title}>
          {settings.get(settingsParams.blogPostsEmptyStateTitle)}
        </Text>
      </div>
    </div>
  );
};
